import { getInstance } from './index'
import { isResponseGridAdmin } from './responseGridAdmin'

export const rgAdminAuthGuard = (to, from, next) => {
  const authService = getInstance()

  const proceed = () => {
    if (!authService.isAuthenticated) {
      return authService.loginWithRedirect({ appState: { targetUrl: to.fullPath } })
    }
    const email = authService.user && authService.user.email
    if (!isResponseGridAdmin(email)) {
      return next({ name: 'EntryPoint' })
    }
    return next()
  }

  if (!authService.loading) {
    return proceed()
  }
  authService.$watch('loading', loading => {
    if (!loading) proceed()
  })
}
